module.exports = __webpack_public_path__ + "img/service.16c7c622.svg";